import React, { FC } from 'react'
import axios from "axios"
import Dialog from '@pixel/core/Dialog'
import { styled } from '@pixel/core/styles'
import LocalizedTypography from '../../components/LocalizedTypography'
import { LocalizedText } from '../../contexts/Localization/LocalizationTypes'
import {AutomationSearchResult} from '../types/Automations'
import DialogContent from "@pixel/core/DialogContent";
import DialogActions from "@pixel/core/DialogActions";
import LocalizedButton from "../../components/LocalizedButton";
import {useMutation, useQueryClient} from "@tanstack/react-query";

const SubtitleText = styled(LocalizedTypography)(({ theme }) => ({
    color: '#808080',
    size: '14px',
    fontWeight: 400,
    paddingTop: theme.spacing(2),
}))

interface AutomationStatusAlertProps {
    selectedAutomation: AutomationSearchResult
    open: boolean
    onClose: () => void
    fetchData: () => void
}
export const AutomationStatusAlert: FC<AutomationStatusAlertProps> = ({
    selectedAutomation,
    open,
    onClose,
    fetchData,
}) => {
    const queryClient = useQueryClient()

    const changeStatus = async (data: any) => {
        const {companyAutomationID, statusValue} = data;
        const CHANGE_AUTOMATION_STATUS_ENDPOINT = `/admin/action/automation/admin/rule/${companyAutomationID}/status/${statusValue}`;
        try {
            const response = await axios.put(CHANGE_AUTOMATION_STATUS_ENDPOINT);
            if(response.status === 201 || response.status === 200) {
                selectedAutomation.status = statusValue;
                fetchData();
            }
        } catch (e) {
            console.log(e.message);
        }
        await queryClient.invalidateQueries({
            queryKey: ['updateAutomation']
        })
        onClose()
    }

    const mutation = useMutation(changeStatus);

    const onStatusChange = (data: any) => {
        mutation.mutate(data);
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
        >
            <DialogContent
                sx={{ width: 520}}
            >
            <LocalizedTypography variant="h2"
                                 text={selectedAutomation?.status === 'ACTIVE'
                                     ? LocalizedText.AUTOMATION_STATUS_MAKE_INACTIVE
                                     : LocalizedText.AUTOMATION_STATUS_MAKE_ACTIVE}
            />
            <SubtitleText variant="body1"
                          text={selectedAutomation?.status === 'ACTIVE'
                                ? LocalizedText.AUTOMATION_STATUS_MAKE_INACTIVE_SUBTITLE
                                : LocalizedText.AUTOMATION_STATUS_MAKE_ACTIVE_SUBTITLE}
            />
            </DialogContent>
            <DialogActions>
                <LocalizedButton
                    text={LocalizedText.Cancel}
                    variant="text"
                    color="secondary"
                    onClick={onClose}
                />
                <LocalizedButton
                    text={LocalizedText.AUTOMATION_FORM_CONFIRM}
                    variant="contained"
                    color="primary"
                    onClick={() => {
                    const statusValue = selectedAutomation.status !== 'ACTIVE' ? 'ACTIVE' : 'INACTIVE';
                        const data = {
                        companyAutomationID : selectedAutomation.companyAutomationId,
                        statusValue,
                    }
                        onStatusChange(data)
                }}
                />
            </DialogActions>
        </Dialog>
    )
}

export default AutomationStatusAlert
